export const TYPED_SIGNATURE_FONT = '"Alex Brush", cursive';

const MAX_FONT_SIZE = 56;
const PADDING = 20;

export const fitTypedSignatureFontSize = (widthAtMaxSize: number, availableWidth: number): number =>
  widthAtMaxSize <= availableWidth ? MAX_FONT_SIZE : Math.floor((MAX_FONT_SIZE * availableWidth) / widthAtMaxSize);

export const loadTypedSignatureFont = async (): Promise<void> => {
  await document.fonts.load(`${MAX_FONT_SIZE}px ${TYPED_SIGNATURE_FONT}`);
};

export const paintTypedSignature = (canvas: HTMLCanvasElement, name: string): void => {
  const ratio = Math.max(window.devicePixelRatio || 1, 1);
  const width = canvas.offsetWidth;
  const height = canvas.offsetHeight;

  canvas.width = width * ratio;
  canvas.height = height * ratio;

  const context = canvas.getContext("2d");
  if (!context || !name) return;

  context.scale(ratio, ratio);
  context.font = `${MAX_FONT_SIZE}px ${TYPED_SIGNATURE_FONT}`;
  const fontSize = fitTypedSignatureFontSize(context.measureText(name).width, width - PADDING * 2);

  context.font = `${fontSize}px ${TYPED_SIGNATURE_FONT}`;
  context.fillStyle = "#000";
  context.textBaseline = "middle";
  context.fillText(name, PADDING, height / 2);
};
